<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    New Folder
</h1>

<form>
    <div mat-dialog-content id="matDialogContent" class="mat-dialog-content">
        <mat-form-field appearance="outline">
            <mat-label>Folder Name</mat-label>
            <input matInput [(ngModel)]="data.folderName" placeholder="Folder Name" name="folderName" autocomplete="off" required />
        </mat-form-field>

        <div *ngIf="data.showTransparentOption">
            <mat-checkbox name="transparent-folder-checkbox"
                          [(ngModel)]="data.isTransparentFolder">Transparent Folder</mat-checkbox>
            <mat-icon class="info-mat-icon"
                      matTooltip="Form instances in a transparent folder receive permissions settings from the transparent folder but appear in the parent folder."
                      matTooltipPosition="above">info</mat-icon>
        </div>
        <div *ngIf="data.showRootFolderOption">
            <mat-checkbox name="root-folder-checkbox"
                          [disabled]="data.isRootFolder"
                          [(ngModel)]="data.isRootFolder">
                Add at root level
            </mat-checkbox>
        </div>

    </div>

    <div mat-dialog-actions id="matDialogActions">
        <button mat-flat-button type="submit" color="primary" class="theme-primary-btn"
                [disabled]="!(data && data.folderName && data.folderName.trim().length > 0)"
                [mat-dialog-close]="data">
            OK
        </button>
        <button mat-flat-button [mat-dialog-close]="null" style="margin-left: 10px;">Cancel</button>
    </div>
</form>
